import jwtDecode from 'jwt-decode';
import axios from './axios';

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return false;
  }
};

// Gestion du token en session
const setSession = (accessToken, role) => {
  if (accessToken) {
    window.localStorage.setItem('accessToken', accessToken);
    window.localStorage.setItem('role', role);
    axios.defaults.headers.common.Authorization = `Token ${accessToken}`;
    axios.defaults.headers.post['Content-Type'] = 'application/json';

    // Optionnel : vérifier expiration et agir avant qu'il n'expire
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('role');
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession };
